export default function _isNativeFunction(fn){return-1!==Function.toString.call(fn).indexOf("[native code]")}